import React, { Component } from "react";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";
import Avatar from "@material-ui/core/Avatar";
import IconButton from "@material-ui/core/IconButton";
import AddIcon from "@material-ui/icons/Add";
import DeleteIcon from "@material-ui/icons/Delete";

const classes = {
	vCenter: {
		display: "flex",
		alignItems: "center"
	},
	textField: {
		width: "100%"
	},
	card: { padding: "20px" }
};

export default class MeetingAgenda extends Component {
	state = {
		title: "",
		summary: "",
		order: "",
		file: "./cpp",
		agendas: [
			{
				title: "Lab Agenda",
				summary: "lorem ispsum dolor sit amet",
				order: "1",
				file: "./cpp",
				allowComments: true
			},
			{
				title: "Lab Agenda",
				summary: "lorem ispsum dolor sit amet",
				order: "1",
				file: "./cpp",
				allowComments: true
			}
		]
	};

	handleChange = e => {
		this.setState({
			[e.target.name]: e.target.value
		});
	};

	addAgenda = () => {
		if (
			this.state.title !== "" &&
			this.state.summary !== "" &&
			this.state.order !== ""
		) {
			let newAgenda = {
				title: this.state.title,
				summary: this.state.summary,
				order: this.state.order
			};
			this.setState({
				agendas: [...this.state.agendas, newAgenda]
			});
		}
	};

	deleteAgenda = index => {};

	render() {
		return (
			<Grid container>
				<Grid xs={12}>
					<Paper style={classes.card}>
						<Grid container spacing={3}>
							<Grid item xs={6}>
								<form action="#">
									<TextField
										id="outlined-name"
										label="Title"
										name="title"
										className={classes.textField}
										value={this.state.title}
										onChange={this.handleChange}
										variant="outlined"
										margin="normal"
										style={{ width: "100%" }}
									/>
									<TextField
										id="outlined-multiline-static"
										label="Summary"
										name="summary"
										multiline
										rows="4"
										className={classes.textField}
										onChange={this.handleChange}
										variant="outlined"
										margin="normal"
										style={{ width: "100%" }}
									/>
									<TextField
										id="outlined-number"
										label="Order"
										name="order"
										value={this.state.order}
										onChange={this.handleChange}
										className={classes.textField}
										type="number"
										InputLabelProps={{
											shrink: true
										}}
										style={{ width: "100%" }}
										margin="normal"
										variant="outlined"
									/>
									<div
										style={{
											display: "flex",
											justifyContent: "space-between",
											marginTop: 16
										}}
									>
										<Button variant="contained" component="label">
											Upload File
											<input type="file" style={{ display: "none" }} />
										</Button>
										<Button
											variant="contained"
											color="default"
											className={classes.button}
											startIcon={<AddIcon />}
											onClick={this.addAgenda}
										>
											Add
										</Button>
									</div>
								</form>
							</Grid>
							<Grid item xs={6}>
								<List>
									{this.state.agendas.map((agenda, index) => (
										<ListItem
											style={{
												border: "1px solid rgba(63, 81, 181, 0.5)",
												borderRadius: "5px",
												margin: "5px 0px"
											}}
										>
											<ListItemAvatar>
												<Avatar>{index + 1}</Avatar>
											</ListItemAvatar>
											<ListItemText primary={agenda.title} />
											<ListItemSecondaryAction>
												<IconButton
													edge="end"
													aria-label="delete"
													onClick={() => {
														this.deleteAgenda(index);
													}}
												>
													<DeleteIcon />
												</IconButton>
											</ListItemSecondaryAction>
										</ListItem>
									))}
								</List>
							</Grid>
						</Grid>
					</Paper>
				</Grid>
			</Grid>
		);
	}
}
